import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { bodyClass: 'home' }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/press',
      name: 'press',
      component: () => import(/* webpackChunkName: "press" */ './views/Press.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import(/* webpackChunkName: "projects" */ './views/Projects.vue'),
    },
    {
      path: '/projects/:slug',
      name: 'project',
      component: () => import(/* webpackChunkName: "single-project" */ './views/projects/SingleProject.vue'),
    },
    {
      path: '*',
      redirect: { name: 'projects' }
    },
  ],
})

export default router
